(function background_images() {
  document.querySelectorAll("[data-background-image]").forEach(element => {
    const desktop = element.getAttribute("data-background-image");
    const mobile = element.getAttribute("data-background-image-mobile");

    Theme.Helpers.preload(desktop);
    Theme.Helpers.preload(mobile);

    initialize();

    window.addEventListener("resize", Theme.Helpers.debounce(initialize, 150));

    function initialize() {
      let background;

      if (window.innerWidth <= 768 && mobile) {
        background = mobile;
      } else {
        background = desktop;
      }

      if (background) {
        element.style.backgroundImage = `url('${background}')`;
      }
    };
  });
})();
